var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#C2CFE0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12.0228V3.92253C21 3.41303 20.587 3 20.0775 3H11.9772C11.7326 3 11.4979 3.09719 11.3249 3.2702L3.79742 10.7977C2.73419 11.8609 2.73419 13.5848 3.79742 14.648L9.352 20.2026C10.4152 21.2658 12.1391 21.2658 13.2023 20.2026L20.7298 12.6751C20.9028 12.5021 21 12.2674 21 12.0228ZM19.1549 11.6406L11.8977 18.8979C11.555 19.2406 10.9993 19.2406 10.6567 18.8979L5.10208 13.3433C4.75938 13.0007 4.75938 12.445 5.10208 12.1023L12.3594 4.84505H19.1549V11.6406ZM14.6773 11.1227C13.6832 11.1227 12.8773 10.3168 12.8773 9.32268C12.8773 8.32861 13.6832 7.52263 14.6773 7.52263C15.6714 7.52263 16.4774 8.32861 16.4774 9.32268C16.4774 10.3168 15.6714 11.1227 14.6773 11.1227Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/Tags.808b859d.svg";
export { ForwardRef as ReactComponent };